// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter  from 'vue-router'

import './assets/css/base.css'
import './assets/css/main.css'
import './assets/css/ui.css'
import './assets/css/liangzi.css'

import "@/assets/fonts/FZHei.css"
import "@/assets/fonts/FZXBSJW.css"
import "@/assets/fonts/simfang.css"
import "@/assets/fonts/simhei.css"
import "@/assets/fonts/simkai.css"
import "@/assets/fonts/simsun.css"
import "@/assets/fonts/SourceHanSansCN.css"
import "@/assets/fonts/FZCUSONG-B09S.css"
import "@/assets/fonts/FZDaHei-B02S.css"

import global from './assets/js/global.js'
import ShowToast from './assets/js/toast'
import ShowInputBox from './assets/js/inputBox'
import ShowMsgBox from './assets/js/msgBox'
import ShowMsgShow from './assets/js/msgShow'
import ShowLoading from './assets/js/loading'
import VueClipboard  from 'vue-clipboard2'
import Print from './components/print'

import VueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
Vue.component('vue-custom-scrollbar', VueCustomScrollbar);


Vue.use(ShowToast)
Vue.use(ShowInputBox)
Vue.use(ShowMsgBox)
Vue.use(ShowMsgShow)
Vue.use(ShowLoading)
Vue.use(VueClipboard)
Vue.use(Print)

Vue.prototype.$global = global
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false


/* 防止push重复路由 */

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js